import React from 'react'
import Footer from '../Footer/Footer'
import Form from '../Form/Form'

function Home() {
    return (
        <div>
            <Form />
            <Footer />
        </div>
    )
}

export default Home